import * as React from 'react';

var _g, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgPhantom = function SvgPhantom(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 121"
    }, props), _g || (_g = /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#clip0_1428_409)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint0_linear_1428_409)",
        d: "M60 120.031c33.137 0 60-26.863 60-60s-26.863-60-60-60-60 26.863-60 60 26.863 60 60 60"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint1_linear_1428_409)",
        d: "M103.671 60.888H92.944c0-21.702-17.783-39.294-39.722-39.294-21.666 0-39.281 17.161-39.712 38.492-.447 22.049 20.464 41.195 42.756 41.195h2.804c19.652 0 45.993-15.219 50.109-33.762.76-3.418-1.97-6.63-5.508-6.63m-66.39.967c0 2.902-2.399 5.276-5.332 5.276-2.934 0-5.334-2.375-5.334-5.276V53.32c0-2.902 2.4-5.276 5.334-5.276s5.333 2.374 5.333 5.276zm18.52 0c0 2.902-2.4 5.276-5.333 5.276s-5.334-2.375-5.334-5.276V53.32c0-2.902 2.4-5.276 5.334-5.276S55.8 50.418 55.8 53.32z"
    }))), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_linear_1428_409",
        x1: 60,
        x2: 60,
        y1: 0.031,
        y2: 120.031,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#534BB1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#551BF9"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint1_linear_1428_409",
        x1: 61.404,
        x2: 61.404,
        y1: 21.594,
        y2: 101.281,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#fff"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#fff",
        stopOpacity: 0.82
    })), /*#__PURE__*/ React.createElement("clipPath", {
        id: "clip0_1428_409"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 .031h120v120H0z"
    })))));
};

export { SvgPhantom as ReactComponent };
//# sourceMappingURL=Phantom.svg.es.js.map
